<div class="imageIcon">
  <img [src]="uploadIcon" />
  <p>{{ label }}</p>
  <p>{{ detail }}</p>
</div>
